import http from '@/utils/http'

// export function getHomeBannerList (params) {
//   return http.postJson('/api/getBanner', params)
// }

/**
 * 轮播图
 * @returns 
 */
export function getHomeBannerList () {
  return http.get('/edu/api/getBanner')
}

/**
 * 友情链接
 * @returns 
 */
export function getHomeFriendLink () {
  return http.get('/edu/api/getFriendLink')
}

/**
 * 获取首页文章
 * @returns 
 */
export function getHomeArticleList () {
  return http.get('/edu/api/getHomeArticleList')
}

/**
 * 获取文章列表
 * @param {*} params 
 * @returns 
 */
export function getArticleList (params) {
  if (!params.pageSize) {
    params.pageSize = 10;
  }
  return http.get(`/edu/api/getArticleList/${params.id}?pageNum=${params.pageNum}&pageSize=${params.pageSize}`)
}

/**
 * 获取 最新文章 列表
 * @param {*} params 
 * @returns 
 */
export function getNewArticleList () {
  return http.get('/edu/api/getNewArticleList')
}

/**
 * 获取文章详情
 * @param {*} params 
 * @returns 
 */
export function getArticleDetail (params) {
  return http.get('/edu/api/getArticleDetail/' + params.id)
}

/**
 * 查询证书列表
 * @param {*} params 
 * @returns 
 */
export function getCertList (params) {
  return http.post('/edu//api/getCertList',params)
}

/**
 * 获取证书下载地址
 * @param {*} params 
 * @returns 
 */
export function downloadCert (params) {
  return http.get(`/edu/api/downloadCert/${params.id}`)
}
